var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Criar Regra")]),_c('create-form',{on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }